module.exports = __webpack_public_path__ + "static/media/33.a1f3a2df.jpg";